var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdf1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_7007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.86328V6.73828H13.5254V9.86328H12.5ZM2.05078 4.15039V18.75H16.6504V20.8008H2.05078C1.49739 20.8008 1.01725 20.5973 0.610352 20.1904C0.203448 19.7835 0 19.3034 0 18.75V4.15039H2.05078ZM7.27539 7.8125V6.73828H8.30078V7.8125H7.27539ZM19.2383 6.73828V5.17578H16.1133V11.4258H17.6758V9.375H19.2383V7.8125H17.6758V6.73828H19.2383ZM15.0879 9.86328V6.73828C15.0879 6.3151 14.9414 5.94889 14.6484 5.63965C14.3555 5.3304 13.9811 5.17578 13.5254 5.17578H10.9375V11.4258H13.5254C13.9811 11.4258 14.3555 11.2712 14.6484 10.9619C14.9414 10.6527 15.0879 10.2865 15.0879 9.86328ZM9.86328 7.8125V6.73828C9.86328 6.3151 9.70866 5.94889 9.39941 5.63965C9.09017 5.3304 8.72396 5.17578 8.30078 5.17578H5.71289V11.4258H7.27539V9.375H8.30078C8.72396 9.375 9.09017 9.22038 9.39941 8.91113C9.70866 8.60189 9.86328 8.23568 9.86328 7.8125ZM18.75 0C19.3034 0 19.7835 0.203448 20.1904 0.610352C20.5973 1.01725 20.8008 1.49739 20.8008 2.05078V14.5508C20.8008 15.1042 20.5973 15.5924 20.1904 16.0156C19.7835 16.4388 19.3034 16.6504 18.75 16.6504H6.25C5.69661 16.6504 5.20833 16.4388 4.78516 16.0156C4.36198 15.5924 4.15039 15.1042 4.15039 14.5508V2.05078C4.15039 1.49739 4.36198 1.01725 4.78516 0.610352C5.20833 0.203448 5.69661 0 6.25 0H18.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_7007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8008,
    height: 20.8008,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf1);
export default __webpack_public_path__ + "static/media/icon_pdf1.9f336b574422fa64cb2bd8a55e7e03a9.svg";
export { ForwardRef as ReactComponent };